import { SET_ENTITY_DATA, SET_SOURCE_DATA } from './mutation-types'
import entityService from 'src/services/entity.service'

const state = {
  entity: {},
  source: {},
}

const mutations = {
  [SET_ENTITY_DATA](state, data) {
    state.entity = data
  },
  [SET_SOURCE_DATA](state, data) {
    state.source = data
  },
}

const actions = {
  getEntity({ commit }, id) {
    return entityService.getEntityData(id).then(res => {
      commit(SET_ENTITY_DATA, res.data)
    })
  },
  getSource({ commit }, id) {
    return entityService.getEntitySourceAttribution(id).then(res => {
      commit(SET_SOURCE_DATA, res.data.data)
    })
  },
}

const getters = {
  entity: state => state.entity,
  source: state => state.source,
  getDataByField: state => field => {
    return _.get(state.entity, field)
  },
  isDataAvailable: state => field => {
    return (
      _.get(state.entity, `_data_available.${field}`) ||
      _.get(state.entity, `_hidden.${field}`)
    )
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
